<template>
  <footer class="app-footer">
    <a href="http://salcomsa.com/" target="_blank"> Salcom S.A</a> &copy; {{ year }}.
  </footer>
</template>
<script>
export default {
  name: 'app-footer',
  data () {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue